import { Bike, Car } from "lucide-react";
import { useZone } from "../context/ZoneContext";
import { isNoldDomain } from "./domain";

// Identité dynamique selon la zone (Frontend uniquement).
// Europe -> "Nold Go" + icône voiture ; Afrique -> "Mboa Go" + icône moto.
export function useBrand() {
  const { zone } = useZone();
  // Identité par DOMAINE : noldgo.com → Nold Go ; tout autre domaine → Mboa Go (zone pilotée par ZoneContext).
  const isEurope = isNoldDomain() ? true : (zone === "europe");
  return {
    isEurope,
    name: isEurope ? "Nold Go" : "Mboa Go",
    firstWord: isEurope ? "Nold" : "Mboa",
    Icon: isEurope ? Car : Bike,
  };
}
